var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "companies" }, [
    _vm.hasCompanies
      ? _c("header", [_c("h1", [_vm._v("\n\t\t\tChoose a company!\n\t\t")])])
      : !_vm.hasCompanies
        ? _c("header", [_c("h1", [_vm._v("\n\t\t\tLoading...\n\t\t")])])
        : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_vm.companies, function(company) {
        return _c("Company", {
          key: company.subscriptionId,
          attrs: {
            company: company.company,
            subscriptionId: company.subscriptionId,
            subscriptionExpireDate: company.subscriptionExpireDate
          }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4af00d07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af00d07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Companies/Companies.vue
// module id = null
// module chunks = 